var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 18C1 27.3854 8.61458 35 18 35C27.3854 35 35 27.3854 35 18C35 8.61458 27.3854 0.999999 18 0.999999C8.61459 0.999998 1 8.61458 1 18Z","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M18.5866 10.9168L25.615 18.0001L18.5866 25.0834","stroke":" currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M24.6377 18L10.3851 18","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Right.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Right;

Right.default = Right;
